<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromDb" ref="fromDb" class="demo-form-inline" @submit.native.prevent>
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-form-item :label="$t('pgCommon.DATABASE_NAME')" prop="caption">
                            <td-input v-model="fromDb.caption" @keyup.enter.native="btnQuery"></td-input>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddSYS">{{ $t('pgCommon.ADD') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <td-permission :permissions="permissionsView" style="display:auto;">
                <div slot="havePermission">
                    <!-- 加载表格 -->
                    <td-table
                        :columns="columns"
                        :dataSource="tableData"
                        :pageSize="pageSize"
                        :currentPage="currentPage"
                        :total="total"
                        :rowKey="id"
                        :hasMutiSelect="false"
                        @handleSizeChange="handleSizeChange"
                        @currentChange="currentChange"
                    ></td-table>
                    <!-- 加载dialog -->
                    <dialog-DbInfo
                        v-if="dialogDbVisible"
                        :isAddData="isAddData"
                        :dialogDbVisible="dialogDbVisible"
                        :editItem="editItem"
                        :title="title"
                        @dbDialogClose="dbDialogClose"
                        @btnQuery="btnQuery"
                    ></dialog-DbInfo>
                </div>
            </td-permission>
        </el-main>
    </el-container>
</template>
<script>
import databaseApi from './assets/api.js';
import dialogDbInfo from './components/dialogDbInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-DbInfo': dialogDbInfo
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.listQuery();
    },
    // 定义数据
    data() {
        return {
            permissionsView: ['configTable:view'],
            permissionsAdd: ['configTable:add'],
            permissionsDel: ['configTable:del'],
            permissionsEdit: ['configTable:edit'],
            fromDb: { caption: '' },
            editItem: '',
            dialogDbVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            columns: [
                {
                    prop: 'caption',
                    label: 'pgCommon.NAME'
                },
                {
                    prop: 'dbTypeName',
                    label: 'pgCommon.DATABASE_TYPE',
                    align: 'center'
                },
                {
                    prop: 'dbName',
                    label: 'pgCommon.DATABASE_CAPTION'
                },
                {
                    prop: 'ip',
                    label: 'pgCommon.DATABASE_IP',
                    align: 'center'
                },
                {
                    prop: 'port',
                    label: 'pgCommon.DATABASE_PORT',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'pgCommon.OPERATE',
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        if (window.pgCommon.defaultDatabase.id === params.row.id) {
                            return '';
                        }
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.id);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.listQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.listQuery();
        },
        // 查询按钮
        btnQuery() {
            this.currentPage = 1;
            this.listQuery();
        },
        // 查询数据
        listQuery() {
            this.loading = true;
            var param = {
                needPage: true,
                caption: this.fromDb.caption,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            databaseApi.queryDbInfo(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('dbManagement/queryDbInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('dbManagement/queryDbInfo', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddSYS() {
            this.title = 'pgCommon.DATABASE_ADD'; // 标题
            this.isAddData = true;
            this.dialogDbVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = 'pgCommon.DATABASE_EDIT';
            this.isAddData = false;
            this.dialogDbVisible = true;
        },
        // 删除接口
        delete(id) {
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    var param = { id: id, sId: id };
                    databaseApi.deleteDbInfo(param, response => {
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('dbManagement/deleteDbInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                        this.btnQuery();
                    });
                })
                .catch(e => {});
        },
        // 关闭页面
        dbDialogClose() {
            this.dialogDbVisible = false;
        }
    }
};
</script>
<style></style>
